import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Divider } from 'primereact/divider';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { IconField } from 'primereact/iconfield';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Slider } from "primereact/slider";
import { Calendar } from 'primereact/calendar';



export default function SidebarDetalhesTrocaPecas(props) {
    const { 
       alerta } = props.openModal;
    const [open, setOpen] = useState(false)
    


    const customHeader = (
        <div className="flex align-items-center gap-2">           
            <span className="font-bold text-xl pt-2">{props.title ? props.title : 'Detalhes do Alerta Parts (Peças)'}</span>
        </div>
    );

 

    return (
    
            
            <Sidebar 
                onHide={() => {
                    props.closeModal({
                        ...props.openModal, 
                        visible : false
                    })
                }}
                header={customHeader} 
                visible={props.openModal.visible} 
                style={{width:'50%'}} 
                position="right" 
                className="custom-sidebar"
                {...props}
            >
            <Divider/>   
            <div className="flex flex-wrap gap-0">
                <div className="col-12 md:col-12 pb-2 pt-2">
                    <label className='text-sm'>Descrição</label><br/>
                    <label className='text-xl pt-2'>{alerta.prtalertdescription}</label>
                </div>
            </div>
            <div className="flex flex-wrap gap-0">
                <div className="col-12 md:col-2 pb-2 pt-2">
                    <label className='text-sm'>Data</label><br/>
                    <label className='text-xl pt-2 pt-2'>{alerta.dataalerta}</label>
                </div>
                <div className="col-12 md:col-2 pb-2 pt-2">
                    <label className='text-sm'>Hora</label><br/>
                    <label className='text-xl pt-2'>{alerta.horaalerta?.substr(0,8)}</label>
                </div>
                <div className="col-12 md:col-2 pb-2 pt-2">
                    <label className='text-sm'>RFC-1759 Code</label><br/>
                    <label className='text-xl pt-2'>{alerta.prtalertcode}</label>
                </div>
                <div className="col-12 md:col-2 pb-2 pt-2">
                    <label className='text-sm'>RFC-1759 Group</label><br/>
                    <label className='text-xl pt-2'>{alerta.prtalertgroupo}</label>
                </div>
                <div className="col-12 md:col-2 pb-2 pt-2">
                    <label className='text-sm'>Severity Level</label><br/>
                    <label className='text-xl pt-2'>{alerta.prtalertseveritylevel}</label>
                </div>
                <div className="col-12 md:col-2 pb-2 pt-2">
                    <label className='text-sm'>Trainning Level</label><br/>
                    <label className='text-xl pt-2'>{alerta.prtalerttraininglevel}</label>
                </div>
            </div>
             <div className="flex flex-wrap gap-0">
                <div className="col-12 md:col-3 pb-2 pt-2">
                    <label className='text-sm'>Número Série</label><br/>
                    <label className='text-xl pt-2'>{alerta.numeroserie}</label>
                </div>
                <div className="col-12 md:col-4 pb-2 pt-2">
                    <label className='text-sm'>Marca</label><br/>
                    <label className='text-xl pt-2'>{alerta.marca}</label>
                </div>
                <div className="col-12 md:col-5 pb-2 pt-2">
                    <label className='text-sm'>Modelo</label><br/>
                    <label className='text-xl pt-2'>{alerta.modelo}</label>
                </div>
             </div>

             <div className="flex flex-wrap gap-0">
                <div className="col-12 md:col-3 pb-2 pt-2">
                    <label className='text-sm'>Contador monocromático</label><br/>
                    <label className='text-xl pt-2'>{alerta.contadormonototal}</label>
                </div>
                <div className="col-12 md:col-3 pb-2 pt-2">
                    <label className='text-sm'>Contador colorido</label><br/>
                    <label className='text-xl pt-2'>{alerta.contadorcolortotal}</label>
                </div>
                <div className="col-12 md:col-3 pb-2 pt-2">
                    <label className='text-sm'>Contador total</label><br/>
                    <label className='text-xl pt-2'>{alerta.contadortotalgeral}</label>
                </div>
             </div>
               
              
              
            </Sidebar>
            
        
    );
}
